import React from "react";
import { MainContent } from "../../../styled-components/AttributesStyles";
import { IPlayerTranfer } from "../../../types/IPlayerDetail";
import CustomTable from "../../../ui/Table";
import { StyledHeader } from "../../ClubDetail/ClubFinancial/ClubFinancial";
import LabelText from "../../../ui/LabelText";
import TransferChart from "./TransferChart";
import { ITransferHistory } from "../../../types/IInjuryData";

interface PlayerTransferProps {
  data: IPlayerTranfer[];
  playerTransferRef: React.RefObject<HTMLDivElement>;
}

const PlayerTranfer: React.FC<PlayerTransferProps> = ({ data }) => {
  const specificHeaders = [
    "Date",
    "From Club",
    "To Club",
    "Published Transfer Fee",
  ];
  // Determine the headers and rows to display
  const headers = specificHeaders;
  const rows = data.map((row) => {
    const transferDate = new Date(row.transferDate);
    const isDateInFuture = transferDate > new Date();
    const transferFeeText = row.showCurrencySymbol ? `€${row.transferFeeText}` : row.transferFeeText;
    const displayTransferFee = isDateInFuture && row.transferFeeText === "End Of loan" 
      ? `${transferFeeText}\nfuture date`
      : transferFeeText;
    const newRow: any = {
      Date: new Date(row.transferDate).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric"
      }),
      "From Club": [row.oldClubLogoURL, row.oldClubName , row.oldClubId],
      "To Club": [row.newClubLogoURL, row.newClubName , row.newClubId],
      "Transfer Fee": displayTransferFee,
    };
    return newRow;
  });
  return (
    <div id="player-transfer-div">
      {/* <TransferChart propData={transferHistory} playerTransferData={data} /> */}
      <StyledHeader className="header-content" style={{paddingTop: "14px", border: "0", marginBottom:"-5px"}}>
        <LabelText className="player-family-name" style={{fontSize: "24px"}}>Transfer history</LabelText>
      </StyledHeader>
      {data?.length === 0 && <button className="data-not-available-btn">Data not currently available</button>}
      {data?.length > 0 && <MainContent style={{paddingBottom : "0"}}>
        <CustomTable
          data={data}
          showSpecificColumns={true}
          headers={headers}
          rows={rows}
        />
      </MainContent>}
    </div>
  );
};

export default PlayerTranfer;
